import { useFilterClientContext } from "./filter-client.context";

export function FilterClient() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterClientContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}